export default __webpack_public_path__ + "static/media/teams.5e320948.svg";